export const projects = require('./projects.json')
export const profileLinks = require('./links.json')
export const mySkills = require('./skills.json')

export const profilePhoto = require('./profile.jpg')

export const logo = {
  github: require('./github-logo.png'),
  ct: require('./ct-logo.png'),
  opico: require('./opico-logo.png'),
}

// export const web = {
//   github: {
//     img: require('./github-logo.png'),
//   },
//   ct: {
//     img: require('./ct-logo.png'),
//   },
//   opico: {
//     img: require('./opico-logo.png'),
//   }
// }